import { render, staticRenderFns } from "./classesSgm.vue?vue&type=template&id=132b1a6e&"
import script from "./classesSgm.vue?vue&type=script&lang=js&"
export * from "./classesSgm.vue?vue&type=script&lang=js&"
import style0 from "./classesSgm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports